import { addClass, removeClass } from '@/utils/dom'

let hasModal = false
let hasInitZIndex = false
// 记录弹窗最新的z-index
let zIndex

// 获取遮罩层，没有则创建
const getModal = function () {
  let modalDom = PopupManager.modalDom
  if (modalDom) {
    hasModal = true
  } else {
    hasModal = false
    modalDom = document.createElement('div')
    PopupManager.modalDom = modalDom

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick()
    })
  }

  return modalDom
}

// 弹窗类组件实例
const instances = {}

const PopupManager = {
  modalFade: true,

  getInstance: function (id) {
    return instances[id]
  },

  // 注册组件
  register: function (id, instance) {
    if (id && instance) {
      instances[id] = instance
    }
  },

  // 删除注册的组件
  deregister: function (id) {
    if (id) {
      instances[id] = null
      delete instances[id]
    }
  },

  nextZIndex: function () {
    return PopupManager.zIndex++
  },

  // 弹窗堆栈
  modalStack: [],

  // 点击遮罩层关闭弹窗
  doOnModalClick: function () {
    const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1]
    if (!topItem) return

    const instance = PopupManager.getInstance(topItem.id)
    if (instance && instance.closeOnClickModal) {
      instance.close()
    }
  },

  /**
   * 开启弹窗
   * @param {*} id 弹窗的id
   * @param {*} zIndex 弹窗的遮罩z-index
   * @param {*} dom 遮罩apdend的地方，没有则append到body
   * @param {*} modalClass 遮罩的自定义类
   * @param {*} modalFade 遮罩是否淡入淡出
   */
  openModal: function (id, zIndex, dom, modalClass, modalFade) {
    if (!id || zIndex === undefined) return
    this.modalFade = modalFade

    const modalStack = this.modalStack

    // 是否已经存在
    for (let i = 0, j = modalStack.length; i < j; i++) {
      const item = modalStack[i]
      if (item.id === id) {
        return
      }
    }

    const modalDom = getModal()

    // 添加淡入的动画类
    addClass(modalDom, 'v-modal')
    if (this.modalFade && !hasModal) {
      addClass(modalDom, 'v-modal-enter')
    }
    // 给遮罩添加自定义类
    if (modalClass) {
      const classArr = modalClass.trim().split(/\s+/)
      classArr.forEach(item => addClass(modalDom, item))
    }
    // 去除淡入动画类
    setTimeout(() => {
      removeClass(modalDom, 'v-modal-enter')
    }, 200)

    // 遮罩层的append
    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom)
    } else {
      document.body.appendChild(modalDom)
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex
    }
    modalDom.tabIndex = 0
    // 显示遮罩
    modalDom.style.display = ''

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass })
  },

  // 关闭弹窗时
  closeModal: function (id) {
    const modalStack = this.modalStack
    const modalDom = getModal()

    if (modalStack.length > 0) {
      const topItem = modalStack[modalStack.length - 1]
      if (topItem.id === id) {
        // 顶层弹窗关闭
        // 移除遮罩层的自定义类
        if (topItem.modalClass) {
          const classArr = topItem.modalClass.trim().split(/\s+/)
          classArr.forEach(item => removeClass(modalDom, item))
        }

        // 出栈
        modalStack.pop()
        if (modalStack.length > 0) {
          // 遮罩层的zindex栈顶的值
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex
        }
      } else {
        // 如果不是栈顶的弹窗关闭
        for (let i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1)
            break
          }
        }
      }
    }

    // 没有弹窗
    if (modalStack.length === 0) {
      // 添加弹窗淡出的样式
      if (this.modalFade) {
        addClass(modalDom, 'v-modal-leave')
      }
      setTimeout(() => {
        if (modalStack.length === 0) {
          // 没有弹窗就删除遮罩dom
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom)
          modalDom.style.display = 'none'
          PopupManager.modalDom = undefined
        }
        removeClass(modalDom, 'v-modal-leave')
      }, 200)
    }
  },
}

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || 1500
      hasInitZIndex = true
    }
    return zIndex
  },
  set(value) {
    zIndex = value
  },
})

export default PopupManager
